
import React from "react";
import RegisterForm from "../componenets/register/RegisterForm";

const Register = () =>{
    return(<RegisterForm/>);
};

export default Register;
